/* eslint import/imports-first: 0 */

const serverAuth = authToken => {
    return new Promise((resolve, reject) => {
        // That server is gonna take a while
        setTimeout(() => {
            if (authToken === 'milli') {
                resolve('Yes');
            } else {
                reject('No');
            }
        }, 1500);
    });
};

const authentication = (nextState, replace, next) => {
    const query = nextState.location.query;
    if (query.login) {
        serverAuth(query.login).then(
            () => next(),
            () => {
                replace(`/login${query && query.newLogin ? '?newLogin=true' : ''}`);
                next();
            }
        );
    } else {
        replace(`/login${query && query.newLogin ? '?newLogin=true' : ''}`);
        next();
    }
};

export default authentication;



// WEBPACK FOOTER //
// ./src/Authentication/index.js